import { Button, VStack } from "@abodeminehq/parcel-ui";
import { useQueryClient } from "@tanstack/react-query";
import { createFileRoute, useLocation } from "@tanstack/react-router";
import { useNavigate } from "@tanstack/react-router";
import { usePostHog } from "posthog-js/react";
import { useEffect, useMemo, useState } from "react";
import { useAuthContext } from "~/contexts/auth-context";
import { identifyUserClientSide } from "~/lib/posthog.client";

export const Route = createFileRoute("/callback/")({
  component: Callback,
});

function Callback() {
  const posthog = usePostHog();
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();
  const [showLogout, setShowLogout] = useState(false);

  const { logtoClient, refresh, user, signOut } = useAuthContext();
  // const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const handleSignInCallback = async () => {
      await logtoClient.handleSignInCallback(window.location.href);
      await refresh();

      //clear react query completly
      queryClient.clear();

      //identify user\
      //TODO: add organization id
      // posthog.group('organization', logtoClient. {

      // });

      // setIsLoading(false)
    };

    handleSignInCallback();

    setTimeout(() => {
      setShowLogout(true);
    }, 3000);
  }, []);

  useEffect(() => {
    if (!user) {
      return;
    }

    // Use the utility function to identify user with duplicate prevention
    identifyUserClientSide(posthog, user);

    //get redirect uri from session storage
    if (typeof window !== "undefined" && window.sessionStorage) {
      const redirectUri = sessionStorage.getItem("post_signin_redirect_uri");
      if (redirectUri) {
        //full redirect
        window.location.href = redirectUri;
        sessionStorage.removeItem("post_signin_redirect_uri");
      } else {
        navigate({ to: "/", replace: true });
      }
    } else {
      navigate({ to: "/", replace: true });
    }
  }, [user]);

  // When it's working in progress
  // if (isLoading) {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting...</p>
        {showLogout && (
          <VStack spacing={4}>
            <p>Still here? Try logging out.</p>
            <Button onClick={() => signOut()}>Logout</Button>
          </VStack>
        )}
      </div>
    </div>
  );
  // }

  // return null
}
